'use strict';

export const ENVIRONMENTS = {
  'opengcp-fe-dev.aexp.com': 'E1ePaas',
  'opengcp-fe-dev.americanexpress.com': 'E1ePaas',
  'opengcp-fe-qa.americanexpress.com': 'E2ePaas',
  'opengcp-fe-green1.americanexpress.com': 'E31ePaas',
  'opengcp-fe-green2.americanexpress.com': 'E32ePaas',
  'www.americanexpress.com': 'E3',
  'online.americanexpress.com': 'E3',
  'qwww.americanexpress.com': 'E2',
  'e2qonline.americanexpress.com': 'E2',
  'e1qonline.americanexpress.com': 'E1',
  localhost: 'RELATIVE_HOST',
  default: 'E3',
  local: 'RELATIVE_HOST',
  'ipc2online.americanexpress.com': 'RELATIVE_HOST',
  'ipc1online.americanexpress.com': 'RELATIVE_HOST',
  'ngiorigin-e2qonline.americanexpress.com': 'RELATIVE_HOST',
  'e2qonlinep.americanexpress.com': 'RELATIVE_HOST',
  'e2qonlines.americanexpress.com': 'RELATIVE_HOST',
  'e2qonlinec.americanexpress.com': 'RELATIVE_HOST'
};

/* eslint-disable camelcase */
export const ENV2HOST = {
  e1: 'opengcp-fe-dev.americanexpress.com',
  e2: 'opengcp-fe-qa.americanexpress.com',
  e3_ipc1: 'opengcp-fe-green1.americanexpress.com',
  e3_ipc2: 'opengcp-fe-green2.americanexpress.com'
};
/* eslint-enable camelcase */

console.log('NODE_ENV', process.env.NODE_ENV);
console.log('EPASS_ENV', process.env.EPASS_ENV);
console.log('ENV', process.env.ENV);

let defaultHost =
  typeof window !== 'undefined' && window.location && window.location.hostname
    ? window.location.hostname
    : ENV2HOST[process.env.NODE_ENV];

console.log('defaultHost', defaultHost);

export function setHost(host) {
  defaultHost = host;
}

export function getHost() {
  return defaultHost;
}

export default function getEnvironment(hostname, environments) {
  hostname = hostname || getHost();
  environments = environments || ENVIRONMENTS;
  return environments[hostname] || environments['default'];
}
